import { LIVE_HELP_TOPIC } from '@/queries/constants'
import * as url from '@/client/services/url'

export default function getSessionUrl({
  sessionId,
  seriesId,
  topicName,
  isUserTutor = false,
  isDropInUser = false,
}: {
  sessionId: number
  seriesId: number | null
  topicName: string
  isUserTutor?: boolean
  isDropInUser?: boolean
}): string {
  if (isDropInUser) {
    return url.getSessionUrlById(sessionId)
  }
  if (seriesId != null) {
    return url.getSeriesUrlById(seriesId)
  }
  if (topicName === LIVE_HELP_TOPIC && !isUserTutor) {
    return url.getLiveHelpUrl({})
  }
  return url.getSessionUrlById(sessionId)
}
